import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from 'ui';

import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import { UserSignUpForm } from '../../components/UserSignUpForm/UserSignUpForm';
import { getAuthRoute } from '../../utils/getAuthRoute';

export const SignUp = () => (
  <AuthLayout
    title="Trade recyclables the smart way"
    subtitle="You are only a few steps away from creating your account and getting started with Safi."
  >
    <UserSignUpForm />
    <Typography variant="body2">
      Already have an account?&nbsp;
      <Link component={RouterLink} to={getAuthRoute('/sign-in')}>
        Sign in
      </Link>
    </Typography>
  </AuthLayout>
);
